/**
 * @file Provides jsPlumb to surface for draweing connection on canvas
 * Uses dynamic import to split into chunk in webpack to prevent jsplumb being loaded
 * on other formats
 */
import window from 'bits/global'

export function initiateJsPlumb(): void {
  window.jsPlumbInitiated = true
}
export function getJsPlumb(): Promise<any> {
  return new Promise((resolve) => {
    if (window.jsPlumbInitiated) {
      import('jsplumb')
        .then(({ jsPlumb }) => {
          resolve(jsPlumb)
        })
        .catch((_error) => {
          resolve(undefined)
        })
    } else {
      resolve(undefined)
    }
  })
}
